// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.overall-container {
  display: flex;
}
.overall-container .left-side {
  width: 50%;
  display: flex;
}
.overall-container .left-side .logo-container {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.overall-container .left-side .header-button-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: -8px;
}
.overall-container .left-side .header-button-container .logo-header {
  color: #0A4064;
  font-size: 1.8em;
  font-weight: 600;
}
.overall-container .right-container {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.overall-container .right-container .second-message {
  margin-top: 10px;
}

.no-avail-slots-container {
  display: flex;
  align-items: center;
  padding-left: 13px;
}
.no-avail-slots-container .no-avail-slots-text {
  border-radius: 3px;
  margin-left: 5px;
  background: #FEBF31;
  padding: 3px 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AdminComponent.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;AAUJ;AARI;EACI,UAAA;EACA,aAAA;AAUR;AARQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AAUZ;AARQ;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;AAUZ;AARY;EACI,cDPN;ECQM,gBAAA;EACA,gBAAA;AAUhB;AANI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAQR;AANQ;EACI,gBAAA;AAQZ;;AAJA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAOJ;AALI;ECxCA,kBDyC0B;EACtB,gBAAA;EACA,mBD9BI;EC+BJ,gBAAA;AAOR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.overall-container {\n    display: flex;\n\n    .left-side {\n        width: 50%;\n        display: flex;\n\n        .logo-container {\n            display: flex;\n            flex-direction: column;\n            margin-right: 10px;\n        }\n        .header-button-container {\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            margin-top: -8px;\n\n            .logo-header {\n                color: $dk-blue;\n                font-size: 1.8em;\n                font-weight: 600;\n            }\n        }\n    }\n    .right-container {\n        display: flex;\n        flex-direction: column;\n        width: 50%;\n\n        .second-message {\n            margin-top: 10px;\n        }\n    }\n}\n.no-avail-slots-container {\n    display: flex;\n    align-items: center;\n    padding-left: 13px;\n\n    .no-avail-slots-text {\n        @include borderRadius(3px);\n        margin-left: 5px;\n        background: $important;\n        padding: 3px 6px;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
